/**
 * Swiper carousels for home page:
 *  - Hero background slideshow (fade, auto-play every 5s)
 *  - Brands  → يتحرك لليسار
 *  - Finance → يتحرك لليمين
 */

export function initHomeCarousels() {
  if (typeof Swiper === "undefined") {
    setTimeout(initHomeCarousels, 100);
    return;
  }
  initHeroBgSwiper();
  initBrandsSwiper();
  initFinanceSwiper();
}

function initHeroBgSwiper() {
  var el = document.querySelector(".mk-hero-bg-swiper");
  if (!el) return;

  new Swiper(".mk-hero-bg-swiper", {
    loop: true,
    speed: 800,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    grabCursor: true,
  });
}

function initBrandsSwiper() {
  var el = document.querySelector(".mk-brands-swiper");
  if (!el) return;

  new Swiper(".mk-brands-swiper", {
    slidesPerView: "auto",
    loop: true,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    allowTouchMove: true,
    grabCursor: true,
  });
}

function initFinanceSwiper() {
  var el = document.querySelector(".mk-finance-swiper");
  if (!el) return;

  new Swiper(".mk-finance-swiper", {
    slidesPerView: "auto",
    loop: true,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
      reverseDirection: true,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    allowTouchMove: true,
    grabCursor: true,
  });
}
